import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';
import { useAppSelector } from '../../../hooks/redux';
import {
  setShowWarningModal,
  setPendingNavigation,
} from '../../../store/slices/accountSlice';
import { useDispatch } from 'react-redux';
import { SecondaryButton, WhiteButton } from '../Button/Buttons';

type ModalWarningProps = Readonly<{
  title: string;
  boldDescription?: string;
  description: string | React.JSX.Element;
  handleButton: () => void;
  buttonText?: string;
}>;

export default function ModalWarning({
  title,
  boldDescription,
  description,
  handleButton,
  buttonText = 'Exit',
}: ModalWarningProps) {
  const dispatch = useDispatch();
  const showWarningModal = useAppSelector(
    (state) => state.account.showWarningModal
  );

  return (
    <Dialog
      open={showWarningModal}
      onClose={() => {}}
      className="relative z-10"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-[rgba(24,24,26,0.4)] transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all p-6 data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white">
              <div className="sm:flex sm:items-start sm:gap-4">
                <div className="mt-3 text-center sm:mt-0 sm:text-left">
                  <DialogTitle
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                  >
                    {title}
                  </DialogTitle>
                  <div className="mt-2">
                    <p className="text-sm font-semibold text-gray-500">
                      {boldDescription}
                    </p>
                    <p className="text-sm text-gray-500">{description}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-row-reverse gap-3 mt-4">
              <SecondaryButton onClick={handleButton} size="deleteButton">
                {' '}
                {buttonText}
              </SecondaryButton>
              <WhiteButton
                onClick={() => {
                  dispatch(setShowWarningModal(false));
                  dispatch(setPendingNavigation(null));
                }}
              >
                Cancel
              </WhiteButton>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
